/* tslint:disable:jsx-no-lambda */
import * as React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import { Button, ColumnDefinition, Modal, PagingControl, Pill, PillBox, SORT_STATE, Table, ToggleButton } from '@abb/common-ux';
import { IUserFilterProps, UserFilter } from '@module/userManagement';
import { IConnectedComponent } from '../../reducers';
import { UserDataService } from '../../services/userDataService';
import { IUser, IUserFilterValue, User } from './models';
import { ISearchState, IUserSearchProps } from './reducers';
import { UserModal } from './userModal';

import './userManagement.scss';

export interface IUserManagementState extends ISearchState {
  UserModalForm: IUser;
  UserList: IUser[];
  CurrentUserList?: IUser[];
  filteredList: IUser[];
  showUserModal: boolean;
  showDeleteUserWarningModal: boolean;
  showFilter: boolean;
  totalItemCount: number;
  userToDelete: number;
}

class UserManagementComponent extends React.Component<IUserSearchProps & IConnectedComponent, IUserManagementState> {

  constructor(props: any) {
    super(props);

    this.state = {
      UserModalForm: new User(),
      UserList: [],
      CurrentUserList: undefined,
      filteredList: [],
      showUserModal: false,
      showDeleteUserWarningModal: false,
      showFilter: false,
      totalItemCount: 0,
      userToDelete: 0
    };
  }

  render() {
    const UserColumn = ColumnDefinition as new () => ColumnDefinition<IUser>;

    let page = (
      <div>
        <h3>Not Authorized</h3>
        <p>{this.props.userPermissions.email} is not an authorized user. Please contact your supervisor to correct this.</p>
      </div>
    );

    // Create list of pills
    const pillList: JSX.Element[] = [];

    if (this.props.filter) {
      if (this.props.filter.isAdmin !== undefined) {
        const pillKey = 'Admin Status';
        const lacct = (this.props.filter.isAdmin ? 'Admin' : 'Non-Admin');
        pillList.push(<Pill key={pillKey} id={pillKey} label='Admin Status' value={lacct} onClose={this.onClosePill} onClick={this.onClickPill} />);
      }

      if (this.props.filter.email && this.props.filter.email.length > 0) {
        const pillKey = 'email';
        pillList.push(<Pill key={pillKey} id={pillKey} label='Email' value={this.props.filter.email} onClose={this.onClosePill} onClick={this.onClickPill} />);
      }

      if (!this.props.filter.allScopes && this.props.filter.scopes && this.props.filter.scopes.length > 0) {
        const pillKey = 'scopes';
        pillList.push(<Pill key={pillKey} id={pillKey} label='Scopes' value={this.renderScopePill(this.props.filter.scopes)} onClose={this.onClosePill} onClick={this.onClickPill} />);
      }

      if (this.props.filter.allScopes) {
        const pillKey = 'allScopes';
        pillList.push(<Pill key={pillKey} id={pillKey} label='Scopes' value={'Scoped to all countries'} onClose={this.onClosePill} onClick={this.onClickPill} />);
      }
    }

    if (this.props.userPermissions.isAdmin) {
      page = (
        <div>
          <div className='row'>
            <div className='col-md-12'>

              <div className='row toolbar'>
                <div className='col-md-8 toolbar-title'>User Management</div>
                <div className='col-md-4'>
                  <div className='text-right'>
                    <Button buttonType='primary' buttonSize='default' icon='plus' onClick={() => this.handleToggleUserModal()} />{' '}
                    <PagingControl pageRequested={this.changePage} skip={this.props.skip} top={this.props.filter.display} totalItemCount={this.state.filteredList.length} />{' '}
                    <ToggleButton isToggled={this.state.showFilter} buttonSize='default' buttonType='normal' icon='filter' id='userFilterBtn' onClick={this.toggleFilter} />
                  </div>
                  {this.state.showFilter ? this.renderFilter() : null}
                </div>
              </div>

              <div className='row'>
                <div className='col-md-12'>
                  <PillBox>
                    {pillList}
                  </PillBox>
                </div>
              </div>

              <div className='row'>
                <div className='col-md-12'>
                  <Table data={this.state.CurrentUserList} sortedColumnName={this.props.sortField} sortedColDirection={this.props.sortDirection} headerClick={this.sortColumn} navigateRow={this.handleToggleUserModal} hover={true} emptyMessage={this.state.CurrentUserList ? 'No User Data' : 'Loading...'}>
                    <UserColumn cell={(user) => user.email} header='Email Address' columnName='email' columnWidth={2} />
                    <UserColumn cell={(user) => { if (user.isAdmin) { return 'Admin'; } else { return 'Non-Admin'; } }} header='Admin Status' columnName='isAdmin' columnWidth={1} />
                    <UserColumn cell={(user) => this.renderScopes(user)}  header='Scopes' columnName='scopes' columnWidth={10} />
                  </Table>
                </div>
              </div>
            </div>
            {this.state.showDeleteUserWarningModal ? this.renderDeleteUserWarningModal() : null}
            {this.state.showUserModal ? this.renderUserModal() : null}
          </div>
        </div>
      );
    }

    return (
      page
    );
  }

  renderFilter() {
    return (
      <div className='userFilter' id='userFilter' onClick={this.stopEventPropogation} >
        <UserFilter
          filter={this.props.filter}
          onFilterApply={this.handleApply}
          onClear={this.handleClear}
        />
      </div>
    );
  }

  renderScopes(user: IUser) {
    let returnString: string = '';
    if (user.allScopes) {
      returnString = 'Scoped to all countries';
    } else {
      if (user.scopes) {
        user.scopes.map((s, index) => {
        if (index === 0) {
          returnString = s;
        } else {
          returnString = returnString + ', ' + s;
        }
        });
      }
    }
    return returnString;
  }

  renderScopePill(scopes: string[]) {
    let returnString: string = '';
    if (scopes) {
      scopes.map((s, index) => {
      if (index === 0) {
        returnString = s;
      } else {
        returnString = returnString + ', ' + s;
      }
      });
    }
    return returnString;
  }

  renderDeleteUserWarningModal() {
    return (
      <Modal
        isOpen={this.state.showDeleteUserWarningModal}
        onClose={this.toggleDeleteUserWarningModal}
        header={'DELETE USER'}
        modalClassName='deleteWarningModal'
        overlayClassName='modalOverlay'>

        <p>Are you sure you want to DELETE the User?</p>
        <p>This action cannot be undone.</p>

        <div className='row'>
          <div style={{ textAlign: 'right', paddingRight: '15px' }}>
            <Button buttonType='normal' buttonSize='default' id='cancelDelete' onClick={this.toggleDeleteUserWarningModal}>Cancel</Button>{' '}
            <Button buttonType='primary' buttonSize='default' id='deleteUserButton' onClick={this.handleDelete}>Delete</Button>
          </div>
        </div>
      </Modal>
    );
  }

  renderUserModal() {
    return (
      <UserModal
        user={this.state.UserModalForm}
        isOpen={this.state.showUserModal}
        onClose={this.handleToggleUserModal}
        onCreate={this.handleCreate}
        onUpdate={this.handleUpdate}
        onDelete={this.toggleDeleteUserWarningModal}
      />
    );
  }

  componentDidMount() {
    // This code is so we close the user filter when we click anywhere that's not inside the filter.
    window.addEventListener('click', this.dismissFilter);

    if (this.props.loggedInUser) {
      this.getUsers();
    }
  }

  componentWillUnmount() {
    window.removeEventListener('click', this.dismissFilter);
  }

  componentWillReceiveProps(nextProps: IUserSearchProps) {
    if (nextProps.skip !== this.props.skip) {
      const shortList = this.state.filteredList.slice(nextProps.skip, nextProps.display + nextProps.skip);
      this.setState({ CurrentUserList: shortList });
    }
    if (nextProps.filter !== this.props.filter) {
      this.filterUsers(this.state.UserList, nextProps.filter);
    }
  }

  getUsers = async () => {
      const users = await UserDataService.getUsers(this.props.loggedInUser);
      this.setState({ UserList: users, totalItemCount: users.length, filteredList: users });
      this.filterUsers(this.state.UserList, this.props.filter);
  }

  onClickPill = (pillKey: string) => {
    // Do Nothing
  }

  onClosePill = (pillKey: string) => {
    const newFilter = { ...this.props.filter };

    if (pillKey === 'Admin Status') {
      newFilter.isAdmin = undefined;
    } else {
      newFilter[pillKey] = '';
    }

    this.handleApply(newFilter);
  }

  stopEventPropogation = (e: React.MouseEvent<HTMLDivElement>) => {
    e.nativeEvent.stopImmediatePropagation();
  }

  handleApply = (filter: IUserFilterValue) => {
    const dispatch = this.props.dispatch;
    dispatch({ type: 'USER_FILTER_UPDATE', filter });
  }

  handleClear = () => {
    const dispatch = this.props.dispatch;
    dispatch({ type: 'USER_CLEAR' });
  }

  changePage = (newSkip: number) => {
    const dispatch = this.props.dispatch;
    dispatch({ type: 'USER_PAGING_UPDATE', skip: newSkip });
  }

  updateTableData = (tablePackageList: IUser[], skip: number) => {
    const display = this.props.display;
    this.setState({ CurrentUserList: tablePackageList.slice(skip, display + skip), filteredList: tablePackageList });
  }

  toggleFilter = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.nativeEvent.stopImmediatePropagation();
    this.setState({ showFilter: !this.state.showFilter });
  }

  dismissFilter = () => {
    this.setState({ showFilter: false });
  }

  handleToggleUserModal = (user: IUser = new User()) => {
    this.setState({ UserModalForm: user,  userToDelete: user.id }, this.toggleUserModal);
  }

  toggleUserModal = () => {
    this.setState({ showUserModal: !this.state.showUserModal });
  }

  toggleDeleteUserWarningModal = () => {
    this.setState({ showDeleteUserWarningModal : !this.state.showDeleteUserWarningModal });
  }

  handleCreate = async (user: IUser) => {
    try {
      await UserDataService.createUser(user, this.props.loggedInUser);
      this.getUsers();
      return true;
    } catch (error) {
      return false;
    }
  }

  handleUpdate = async (user: IUser) => {
    try {
      await UserDataService.updateUser(user, this.props.loggedInUser);
      this.getUsers();
      return true;
    } catch (error) {
      return false;
    }
  }

  handleDelete = async () => {
    try {
      await UserDataService.deleteUser(this.state.userToDelete, this.props.loggedInUser);
      this.getUsers();
      this.toggleDeleteUserWarningModal();
      this.toggleUserModal();
    } catch (error) {
      console.log('User delete failed');
    }
  }

  filterUsers = (users: IUser[] | undefined, filter: IUserFilterValue) => {
    if (users !== undefined && filter !== undefined) {
      let newUsersList = users;
      if (filter.email !== undefined) {
        const userEmail = filter.email.toLowerCase();
        newUsersList = newUsersList.filter(user => user.email.toLowerCase().includes(userEmail));
      }
      if (filter.email !== undefined) {
        const userFirstName = filter.email.toLowerCase();
        newUsersList = newUsersList.filter(user => user.email.toLowerCase().includes(userFirstName));
      }
      if (filter.scopes !== undefined) {
        newUsersList = filter.scopes.length !== 0 ? newUsersList.filter(user => filter.scopes.every(s => user.allScopes || (user.scopes.some(scope => scope === s)))) : newUsersList;
      }
      if (filter.isAdmin !== undefined) {
        if (filter.isAdmin) {
          const userTrue = filter.isAdmin.toString();
          newUsersList = newUsersList.filter(user => user.isAdmin!.toString().includes(userTrue));
        }
        if (!filter.isAdmin) {
          const userFalse = filter.isAdmin.toString();
          newUsersList = newUsersList.filter(user => user.isAdmin!.toString().includes(userFalse));
        }
      }
      if (filter.allScopes) {
        const allScopesTrue = filter.allScopes.toString();
        newUsersList = newUsersList.filter(user => user.allScopes!.toString().includes(allScopesTrue));
      }
      const sortedUsers = this.sortData(this.props.sortField, this.props.sortDirection, newUsersList);
      this.updateTableData(sortedUsers, this.props.skip);
    }
  }

  sortData = (sortByField: string, sortDir: string, unsortedList: IUser[]): IUser[] => {
    const rows = unsortedList.slice();
    rows.sort((a: IUser, b: IUser) => {
      let sortVal = 0;

      if (!a[sortByField] && !b[sortByField]) {
        sortVal = 1;
      } else if (!a[sortByField] || a[sortByField] === undefined) {
        sortVal = -1;
      } else if (!b[sortByField] || b[sortByField] === undefined) {
        sortVal = 1;
      } else {
        if (a[sortByField].toString().toLowerCase() > b[sortByField].toString().toLowerCase()) {
          sortVal = 1;
        }
        if (a[sortByField].toString().toLowerCase() < b[sortByField].toString().toLowerCase()) {
          sortVal = -1;
        }
      }
      if (sortDir === 'desc') {
        sortVal = sortVal * -1;
      }
      return sortVal;
    });
    return rows;

  }

  sortColumn = (sortByFieldName: string) => {
    let sortField: string = this.props.sortField;
    let sortDirection: SORT_STATE = this.props.sortDirection;
    if (sortByFieldName) {
      if (this.props.sortField === sortByFieldName) {
        sortDirection = this.toggleSortDirection(this.props.sortDirection);
      } else {
        sortField = sortByFieldName;
        sortDirection = 'asc';
      }
      const sortedList = this.sortData(sortField, sortDirection, this.state.filteredList);
      this.setState({ filteredList: sortedList, CurrentUserList: sortedList.slice(this.props.skip, this.props.display + this.props.skip) });
      const dispatch = this.props.dispatch;
      dispatch({ type: 'USER_SORT_UPDATE', sortField, sortDirection });
    }
  }

  toggleSortDirection = (currentDirection: SORT_STATE) => {
    if (currentDirection === 'asc') {
      return 'desc';
    } else {
      return 'asc';
    }
  }
}

export const UserManagement = withRouter(connect<{}, {}, IUserFilterProps & IUserSearchProps & IConnectedComponent>(mapStateToProps)(UserManagementComponent));

function mapStateToProps(store: any) {
  return {
    loggedInUser: store.userState.loggedInUser,
    userPermissions: store.userState.userPermissions,
    filter: store.userFilter.filter,
    skip: store.userFilter.skip,
    display: store.userFilter.display,
    sortDirection: store.userFilter.sortDirection,
    sortField: store.userFilter.sortField
  };
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./src/modules/userManagement/userManagement.tsx